// extracted by mini-css-extract-plugin
module.exports = {"tagName":"_1ZHVj","wrapper":"gDLFX","card-padding":"_3YNeu","load-more":"_2DM8_"};